import { render } from "./MeldsContainer.vue?vue&type=template&id=b683fe48&scoped=true"
import script from "./MeldsContainer.vue?vue&type=script&lang=js"
export * from "./MeldsContainer.vue?vue&type=script&lang=js"

import "./MeldsContainer.vue?vue&type=style&index=0&id=b683fe48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b683fe48"]])

export default __exports__